import { observer } from "mobx-react-lite";

import { FreestyleBodyFields } from "src/components/FreestyleBodyFields";
import { FreestyleHeaderFields } from "src/components/FreestyleHeaderFields";

import {
  BaseDetailedWorkoutItemGroup,
  type WorkoutItemGroupProps,
} from "./BaseDetailedWorkoutItemGroup";

export const FreestyleDetailedWorkoutItemGroup = observer(
  function FreestyleDetailedWorkoutItemGroup(props: WorkoutItemGroupProps) {
    return (
      <BaseDetailedWorkoutItemGroup
        {...props}
        header={
          <FreestyleHeaderFields workoutItemId={props.item.workoutItemId} />
        }
        body={<FreestyleBodyFields workoutItemId={props.item.workoutItemId} />}
      />
    );
  },
);
